import { all } from 'redux-saga/effects';
import unEmploymentWatcher from './unEmploymentSaga';

export default function* rootSaga(action) {
	yield all([unEmploymentWatcher(action)]);
}
